(function () {
    'use strict';

    angular
        .module('costCenters')
        .config(CostCentersRoute);

    /* @ngInject */
    function CostCentersRoute($stateProvider) {
        $stateProvider
            .state ('root.costCenters', {
                url: '/costcenters',
                abstract: true
            })
            .state ('root.costCenters.list', {
                url: '/list',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/costCenters/templates/costCenters-list.html',
                        controller: 'CostCentersController',
                        controllerAs: 'costCenters'
                    }
                },
                params: {
                    filters: null,
                },
                resolve: {
                    costCenters,
                }
            });
    }
    
    function costCenters($stateParams, CostCentersService) { 
        return CostCentersService.listCostCenters($stateParams.filters);
    }
})();